import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getBannerI18nSubTitleKey, getBannerI18nTitleKey } from '../utils';
import DefaultBanner from './DefaultBanner';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import UIContactSalesButton from '../../button/UIContactSalesButton';
import { useUpgradeDataFromUpgradeConfig } from './useUpgradeDataFromUpgradConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const LimitPackBannerTitle = ({
  featureTranslationKey,
  value,
  limit
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.limitPackBanner.header', featureTranslationKey),
    options: {
      value,
      limit
    }
  });
};
export const LimitPackBannerSubtext = ({
  apiName,
  featureTranslationKey,
  gates
}) => {
  const translatedProductName = getProductNameTextFromApiName(apiName, gates);
  return /*#__PURE__*/_jsx(UIBox, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getBannerI18nSubTitleKey('upgrades.limitPackBanner.subtext', featureTranslationKey),
      options: {
        productName: translatedProductName
      }
    })
  });
};
const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  className,
  style,
  gates,
  'data-test-id': dataTestId = 'limit-pack-banner'
}) => {
  const upgradeData = useUpgradeDataFromUpgradeConfig(upgradePoint);
  const apiNameToUse = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const correctedUpgradeData = Object.assign({
    feature: upgradePoint.feature,
    pointType: upgradePoint.pointType,
    upgradeKey: upgradePoint.upgradeKey
  }, upgradeData);
  const getUpgradeButton = apiName => {
    return /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: apiName,
      upgradeData: correctedUpgradeData,
      use: "tertiary-light",
      isUpgradePoint: true
    });
  };
  if (displayThreshold && value < displayThreshold) {
    return null;
  }
  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: /*#__PURE__*/_jsx(LimitPackBannerTitle, {
      featureTranslationKey: upgradePoint.featureTranslationKey,
      value: value,
      limit: limit
    }),
    className: className,
    dataTestId: dataTestId,
    subtext: /*#__PURE__*/_jsx(LimitPackBannerSubtext, {
      apiName: apiNameToUse,
      featureTranslationKey: upgradePoint.featureTranslationKey,
      gates: gates
    }),
    style: style,
    button: getUpgradeButton(apiNameToUse)
  });
};
export default LimitPackBanner;